import React, { useState } from 'react';

import './LocationMap.scss';
// import FocusStyle from "../styles/variables.module.scss";
import { z } from 'zod';
import { Map, MapProps, Marker } from 'pigeon-maps';
import IconMap from '../assets/iconFocusMap.svg';
import { config } from 'localforage';
import { useAtom, useAtomValue } from 'jotai';
import { focusResaAtom } from '../store/core';

export const map_location = z.object({
	locationId: z.number(),
	title: z.string(),
	coordinates: z.string().nullable(),
	link: z.string(),
	emoji: z.string().nullable().optional(),
});
export type MapLocation = z.infer<typeof map_location>;

export const LocationMap = ({
	locations,
	...props
}: {
	locations: MapLocation[];
} & MapProps) => {

	const focusResa = useAtomValue(focusResaAtom);
	// Use first marker as center
	// If no valid coordinates, use default
	const center = (locations.length > 0 &&
		parseCoordinates(locations[0].coordinates)) || focusResa.defaultGPSCenter;

	const [hovered, setHovered] = useState<number | null>(null);

	return (
		<Map defaultCenter={center} {...props}>
			{locations.map((l) => {
				const point = parseCoordinates(l.coordinates);

				return (
					point && (
						<Marker
							key={l.locationId}
							anchor={point}
							color={'#f05e39' /* FocusStyle.focusOrange */}
							onMouseOver={() => setHovered(l.locationId)}
							onMouseOut={() =>
								setHovered((h) => (h === l.locationId ? null : h))
							}
							onClick={() => (window.location.href = l.link)}
							height={30}
							width={30}
						>
							<LocationMarker hover={hovered == l.locationId} l={l} />
						</Marker>
					)
				);
			})}
		</Map>
	);
};

const LocationMarker = (props: { l: MapLocation; hover: boolean }) => {
	return (
		<div className="marker-container">
			<div className="marker-tooltip">
				<span className="marker-tooltip-text">{props.l.title}</span>
			</div>
			{props.l.emoji ? (
				<div className="marker-icon">{props.l.emoji}</div>
			) : (
				<IconMap width="100%" height="100%" />
			)}
		</div>
	);
};

const parseCoordinates = (
	maybeCoords?: string | null,
): [number, number] | undefined => {
	if (!maybeCoords) return undefined;
	const res = /^(\d+(\.\d+)?),\s*(\d+(\.\d+)?)$/.exec(maybeCoords);
	if (!res) return undefined;

	return [parseFloat(res[1]), parseFloat(res[3])];
};
